import { makeStyles } from '@material-ui/core'

const useStyle = makeStyles(() => {
  return {
    avatar: {
      width: 48,
      height: 48,
      border: '2px solid white',
      marginRight: '-14px',
      fontSize: '1rem',
    },
    container: {
      position: 'relative',
      '&:hover $agentsPlus': {
        // opacity: 1,
        transition: 'all ease 0.3s',
      },
      '&:hover .MuiAvatarGroup-avatar': {
        // opacity: 1,
        transition: 'all ease 0.3s',
      },
    },
    avatarGroup: {
      '& .MuiAvatarGroup-avatar': {
        width: 32,
        height: 32,
        marginLeft: 0,
        fontSize: '1rem',
        '&:hover ~ $container + $agentsPlus': {
          opacity: 1,
        },
      },
    },
    agentsPlus: {
      opacity: 0,
      top: 32,
      left: 15,
      color: 'white',
      position: 'absolute',
      borderRadius: 6,
      width: 122,
      marginLeft: 60,
      marginTop: 14,
      background: 'rgba(97, 97, 97, 0.9)',
      padding: '4px 8px',
      fontSize: 11,
    },
  }
})

export default useStyle
